// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ow-0";